import { rpcClient } from 'FormsUI/utils/rpcClient';
import { getSubscriptionsRpc } from '../../__generated__/chirp/com/hubspot/esp/sync/rpc/FormSubscriptionsRpc';
import { getByGuidRpc } from '../../__generated__/chirp/com/hubspot/collected/forms/rpc/CollectedFormsRpc';
export function getCollectedForm(guid) {
  return rpcClient.call(getByGuidRpc, {
    request: {
      guid
    }
  });
}
export function getSubscriptions(guid) {
  return rpcClient.call(getSubscriptionsRpc, {
    request: {
      formGuid: guid
    }
  });
}